import { usePathname } from 'next/navigation'
import { useEffect, useMemo } from 'react'

import { IS_BRAND_PULSZ } from 'config/brands'
import FooterPortal from 'containers/Layouts/Layout/FooterPortal'
import Slots from 'pageContainers/AllGames/Games'
import Loader from 'src/components/Loader'
import { getFavoritesGames } from 'src/store/modules/favorites/actions'
import { favoritesLoadedSelector } from 'src/store/modules/favorites/selectors'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { getActiveCurrencyIdSelector } from 'store/modules/currencies/selectors'
import { filterBingoGamesByMode } from 'utils/filterBingoGamesByMode'

import MyGamesLayout from '../MyGames/components/MyGamesLayout'

import NoFavoritesGames from './components/NoFavoritesGames'
import classes from './games.module.scss'

import type { FavoritesGamesType } from './types'
import type { GameProduct } from '@patrianna/shared-patrianna-types/store/GameModule'

function Games(props: FavoritesGamesType) {
  const dispatch = useAppDispatch()
  const gamesLoaded = useAppSelector(favoritesLoadedSelector)
  const activeCurrency = useAppSelector(getActiveCurrencyIdSelector)
  const pathname = usePathname()
  const filteredGames = useMemo(
    () => (IS_BRAND_PULSZ ? props.games : filterBingoGamesByMode(props.games, activeCurrency)),
    [activeCurrency, props.games],
  )

  useEffect(() => {
    dispatch(getFavoritesGames())
  }, [pathname])

  return (
    <>
      {!gamesLoaded ? (
        <div className={classes.loadingShell}>
          <Loader />
        </div>
      ) : !filteredGames?.length ? (
        <MyGamesLayout>
          <NoFavoritesGames />
          <FooterPortal />
        </MyGamesLayout>
      ) : (
        <Slots games={filteredGames as GameProduct[]} layout={props.layout} />
      )}
    </>
  )
}
export default Games
